import { getApolloClient } from '@lifesize/nucleus';
export const getClient = async (...args) => {
  const [client] = await getApolloClient(...args);
  return client;
};
